import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDialog,{model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c(VCard,[_c(VCardTitle,[_vm._v(" Añadir fecha inhábil ")]),_c(VCardText,[_c('AddDisabledDateForm',{on:{"save":_vm.close}})],1),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"text":"","color":"error"},on:{"click":_vm.close}},[_vm._v("Cancelar")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }